import cx from "classnames";

import CS from "metabase/css/core/index.css";
import { CopyData } from "metabase/jerry/CopyData";
import QuestionScheduleExportSheet from "metabase/jerry/Spreadsheet/SubscribeExportSheet";
import { useSelector } from "metabase/lib/redux";
import { ViewFooterDownloadWidget } from "metabase/query_builder/components/view/ViewFooter/ViewFooterDownloadWidget";
import {
  getFirstQueryResult,
  getIsTimeseries,
  getQuestion,
  getRawSeries,
  getUiControls,
  getVisualizationSettings,
} from "metabase/query_builder/selectors";
import { getIsObjectDetail } from "metabase/query_builder/selectors/mode";
import { getUser } from "metabase/selectors/user";
import { Group } from "metabase/ui";

import { ExecutionTime } from "../ExecutionTime";
import { QuestionLastUpdated } from "../QuestionLastUpdated/QuestionLastUpdated";
import QuestionRowCount from "../QuestionRowCount";
import QuestionTimelineWidget from "../QuestionTimelineWidget";

import S from "./RightViewFooterButtonGroup.module.css";

export const RightViewFooterButtonGroup = () => {
  const user = useSelector(getUser);
  const question = useSelector(getQuestion);
  const isTimeseries = useSelector(getIsTimeseries);
  const result = useSelector(getFirstQueryResult);
  const { isShowingRawTable } = useSelector(getUiControls);
  const rawSeries = useSelector(getRawSeries);
  const visualizationSettings = useSelector(getVisualizationSettings);
  const isObjectDetail = useSelector(getIsObjectDetail);

  return (
    <Group wrap="nowrap" justify="right" className={S.Root}>
      {QuestionRowCount.shouldRender({
        result,
        isObjectDetail,
      }) && <QuestionRowCount />}
      {ExecutionTime.shouldRender({ result }) && (
        <ExecutionTime time={result.running_time} />
      )}
      <Group gap="sm" wrap="nowrap">
        {QuestionLastUpdated.shouldRender({ result }) && (
          <QuestionLastUpdated
            className={cx(CS.hide, CS.smShow)}
            result={result}
          />
        )}
        {CopyData.shouldRender({ result }) && <CopyData />}
        <ViewFooterDownloadWidget />
        {QuestionScheduleExportSheet.shouldRender({
          user,
          result,
        }) && (
          <QuestionScheduleExportSheet
            key="schedule_export"
            className="mx1 hide sm-show"
            user={user}
            result={result}
            question={question}
            isShowingRawTable={isShowingRawTable}
            rawSeries={rawSeries}
            visualizationSettings={visualizationSettings}
          />
        )}
        {QuestionTimelineWidget.shouldRender({ isTimeseries }) && (
          <QuestionTimelineWidget className={cx(CS.hide, CS.smShow)} />
        )}
      </Group>
    </Group>
  );
};
